import { useEffect, useState } from "react";
import PageLayout from "../../component/PageLayout";
import Pagination from "../../component/Pagination";
import { useFilterPagination } from "../../component/Pagination/useFilterPagination";
import SearchBar from "../../component/SearchFilter";
import IconShorting from "../../component/SvgIcon/IconShorting";
import IconUsers from "../../component/SvgIcon/IconUsers";
import { BootstrapTooltips } from "../../services/BootstrapTooltips";
import api from "../../services/index";
import { useAuth } from "../../services/AuthContext";
import CustomerDetailsModal from "../../component/ModalDialog/CustomerDetailsModal";

export default function PartyList() {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { country: Country } = useAuth();


  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const Tablecolumns = [
    { header: "#", tableid: "sno" },
    { header: "Party Name", tableid: "CustomerName" },
    { header: "Email", tableid: "Email" },
    { header: "Mobile No", tableid: "Mobile" },
    { header: "Area", tableid: "Area" },
    { header: "Address", tableid: "Address" },
    { header: "Country", tableid: "Country" },
    { header: "Business Category", tableid: "CustomerBusiness" },
  ];

  const {
    searchQuery,
    setSearchQuery,
    clearSearch,
    page,
    setPage,
    totalPages,
    paginatedData,
    sortConfig,
    setSortConfig,
  } = useFilterPagination(tableData, {
    defaultPageSize: 10,
    responsivePageSize: 15,
  });

  useEffect(() => {
    BootstrapTooltips();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const customerRes = await api.post("/getCustomers", { country: Country });
        const visitRes = await api.post("/getCustomerVisit", { country: Country });

        const customers = customerRes.data || [];
        const visits = visitRes.data || [];
        console.log("customers", visits);

        // Match by CustomerId and Customer_Id
        const merged = customers.map((customer) => {
          const visit = visits.find(
            (v) => v.Customer_Id === customer.CustomerId
          );
          return {
            ...customer,
            ...visit,
          };
        });

        setTableData(merged);
      } catch (err) {
        console.error("Failed to fetch customer or visit data:", err);
      } finally {
        setLoading(false); // ✅ Set loading false after fetch
      }
    };

    fetchData();
  }, []);

  // ✅ Sorting Logic
  const sortedData = [...paginatedData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const key = sortConfig.key;
    const dir = sortConfig.direction === "asc" ? 1 : -1;
    const valA = (a[key] ?? "").toString().toLowerCase();
    const valB = (b[key] ?? "").toString().toLowerCase();
    return valA > valB ? dir : valA < valB ? -dir : 0;
  });

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  return (
    <PageLayout icon={<IconUsers />} pagetitle="Customer List">
      <div className="topspace">
        <div className="container-fluid">
          <section className="user-section mb-4">
            <div className="filterarea d-flex flex-column gap-3 flex-md-row justify-content-between align-items-center">
              <div />
              <div className="datafilter d-flex gap-3 align-items-center">
                <SearchBar
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  onClear={clearSearch}
                />
                <Pagination
                  currentPage={page}
                  totalPages={totalPages}
                  onPageChange={setPage}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    {Tablecolumns.map((col) => (
                      <th
                        key={col.tableid}
                        className={col.tableid === "action" ? "action" : "cursor-pointer"}
                        onClick={() => {
                          // Skip sorting for non-sortable columns
                          if (["action", "sno", "Area",].includes(col.tableid)) return;

                          setSortConfig((prev) => ({
                            key: col.tableid,
                            direction:
                              prev.key === col.tableid && prev.direction === "asc" ? "desc" : "asc",
                          }));
                        }}
                      >
                        {col.header} {!["action", "sno", "Area",].includes(col.tableid) && (
                          <IconShorting
                            activeDirection={sortConfig.key === col.tableid ? sortConfig.direction : null}
                          />
                        )}
                      </th>
                    ))}

                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={Tablecolumns.length} className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : sortedData.length > 0 ? (
                    sortedData.map((row, rowIndex) => (
                      <tr key={rowIndex} className="cursor-pointer" onClick={() => handleItemClick(row)}>
                        {Tablecolumns.map((col, colIndex) => (
                          <td key={colIndex} className="text-left cursor-pointer">
                            {col.tableid === "sno"
                              ? (page - 1) * 10 + rowIndex + 1
                              : row[col.tableid] ?? "-"}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={Tablecolumns.length} className="text-center">
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </section>
        </div>
      </div>

      <CustomerDetailsModal
        show={showModal}
        customer={selectedItem}
        onClose={() => setShowModal(false)}
      />
    </PageLayout>
  );
}
